import { render } from "./LongtermHeader.vue?vue&type=template&id=f84a4a22"
import script from "./LongtermHeader.vue?vue&type=script&lang=js"
export * from "./LongtermHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__